import { EditableCell, EditableRow } from 'components/EditableComponents';

const useEditableCell = (defaultColumns, handleSave) => {
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const mapEditableColumns = (cols) =>
    cols.map((col) => {
      if (col.children) {
        return {
          ...col,
          children: mapEditableColumns(col.children),
        };
      }

      if (!col.editable) return col;

      return {
        ...col,
        onCell: (record) => ({
          record,
          editable: col.editable,
          dataIndex: col.dataIndex,
          title: col.title,
          inputType: col.inputType,
          handleSave,
        }),
      };
    });
    
  const columns = mapEditableColumns(defaultColumns);

  return {
    components,
    columns
  };
};

export default useEditableCell;
